import { SearchEventLogsApiRequest } from '../../../../types/requests/event-logs/search-event-logs.request';
import { searchEventLogs } from '../../api/event-logs.api';
import { useAxiosInfiniteQuery } from './use-axios.hook';

const baseQueryKey = 'eventLog';
const searchQueryKey = 'search';

export const useSearchEventLogs = (params: SearchEventLogsApiRequest) => {
  const { data, ...result } = useAxiosInfiniteQuery({
    queryKey: [baseQueryKey, searchQueryKey, params],
    queryFn: async ({ pageParam }) => (await searchEventLogs({ cursor: pageParam, ...params })).data,
    initialPageParam: params.cursor,
    getNextPageParam: (lastResponse) => lastResponse.nextCursor,
  });
  return { ...result, response: data } as const;
};
